module.exports = "https://coursera_assets.s3.amazonaws.com/images/ca211134ae0dbe9705fbf2d7ba00d1dd.png";